// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrelanderLimitedOfferPage__container--E9qfQ {
    position: relative;
    background-color: var(--darkest-color);
}

.PrelanderLimitedOfferPage__root--pc2Vf {
    padding: 16px;
    width: 100%;
    max-width: 860px;
    margin: 0 auto;
    min-height: 100vh;
    min-height: calc(var(--vh) * 100);
    display: flex;
    flex-direction: column;
    gap: 28px;
    position: relative;
    z-index: 2;
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.PrelanderLimitedOfferPage__root--pc2Vf {
        padding: 32px 0;
        min-height: 100vh;
        justify-content: space-between;
        gap: 24px
}
    }

.PrelanderLimitedOfferPage__header--GesUT {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.PrelanderLimitedOfferPage__header--GesUT {
        margin-bottom: 32px
}
    }

.PrelanderLimitedOfferPage__logo--JVGpG > img {
        width: 103px;
        height: 24px;
    }

.PrelanderLimitedOfferPage__title--DYN1j {
    color: var(--tertiary-color);
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    text-transform: uppercase;
    margin-bottom: 24px;
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.PrelanderLimitedOfferPage__title--DYN1j {
        font-size: 32px;
        line-height: 34px;
        margin-bottom: 32px
}
    }

.PrelanderLimitedOfferPage__divider--ih0Oh {
    width: 48px;
    height: 1px;
    background-color: var(--secondary-color);
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.PrelanderLimitedOfferPage__divider--ih0Oh {
        width: 144px
}
    }

.PrelanderLimitedOfferPage__divider--ih0Oh.PrelanderLimitedOfferPage__center--U06Sa {
        margin: 0 auto;
    }

.PrelanderLimitedOfferPage__countdownBlock--cK6Dy {
    margin-bottom: 28px;
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.PrelanderLimitedOfferPage__countdownBlock--cK6Dy {
        margin-bottom: 40px
}
    }

.PrelanderLimitedOfferPage__countdownBlockLabel--fz1lK {
    color: var(--secondary-color);
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    text-transform: uppercase;
    margin-bottom: 8px;
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.PrelanderLimitedOfferPage__countdownBlockLabel--fz1lK {
        margin-bottom: 2px
}
    }

.PrelanderLimitedOfferPage__countdownBlockTitle--rU41a {
    color: var(--tertiary-color);
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    text-transform: uppercase;
    margin-bottom: 8px;
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.PrelanderLimitedOfferPage__countdownBlockTitle--rU41a {
        font-size: 32px;
        line-height: 34px;
        margin-bottom: 24px
}
    }

.PrelanderLimitedOfferPage__offerBlock--gZmRS {
    display: flex;
    flex-direction: column;
    gap: 28px;
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.PrelanderLimitedOfferPage__offerBlock--gZmRS {
        display: grid;
        grid-template-columns: 420px auto;
        align-items: start;
        grid-gap: 20px
}
    }

.PrelanderLimitedOfferPage__cardsBox--eflXI {
    border-radius: 6px;
    border: 1px solid var(--premium-solid-color);
    position: relative;
    overflow: hidden;
}

.PrelanderLimitedOfferPage__cardsBoxImage--HJcyF {
    width: 100%;
    height: auto;
    aspect-ratio: 4.2 / 3.6;
}

.PrelanderLimitedOfferPage__cardsBoxDescription--j6yoI {
    color: var(--premium-solid-color);
    text-align: center;
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 16px;
}

.PrelanderLimitedOfferPage__cardsBoxDescription--j6yoI > strong {
        font-weight: 900;
    }

.PrelanderLimitedOfferPage__additionalText--AXNNJ {
    color: var(--premium-solid-color);
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: 0.84px;
    text-transform: uppercase;
    padding: 8px 16px 0 16px;
}

.PrelanderLimitedOfferPage__startedBlock--qz2pp {
    border-radius: 6px;
    border: 1px solid var(--dark-tertiary-new-color);
    padding: 16px;
}

.PrelanderLimitedOfferPage__startedBlockTitle--nbAzC {
    color: var(--tertiary-color);
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    text-transform: uppercase;
    margin-bottom: 16px;
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.PrelanderLimitedOfferPage__startedBlockTitle--nbAzC {
        font-size: 28px;
        line-height: 32px;
        margin-bottom: 32px
}
    }

.PrelanderLimitedOfferPage__list--d0ilI {
    margin: 24px 0;
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.PrelanderLimitedOfferPage__list--d0ilI {
        margin: 32px 0
}
    }

.PrelanderLimitedOfferPage__listItem--lHBTR {
    display: grid;
    grid-template-columns: 14px auto;
    grid-gap: 8px;
    color: var(--tertiary-color);
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
}

.PrelanderLimitedOfferPage__listItem--lHBTR:not(:last-child) {
        margin-bottom: 8px;
    }

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.PrelanderLimitedOfferPage__listItem--lHBTR {
        font-size: 16px;
        line-height: 20px
}

        .PrelanderLimitedOfferPage__listItem--lHBTR:not(:last-child) {
            margin-bottom: 24px;
        }
    }

.PrelanderLimitedOfferPage__button--hSCoZ {
    width: 100%;
    padding: 16px;
}

.PrelanderLimitedOfferPage__copyrightText--ZSRxs {
    color: var(--dark-fourth-new-color);;
    text-align: center;
    font-size: 10px;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0.1px;
    text-transform: uppercase;
    margin-top: 16px;
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.PrelanderLimitedOfferPage__copyrightText--ZSRxs {
        margin: 0 auto;
        margin-top: 24px;
        max-width: 604px
}
    }

.PrelanderLimitedOfferPage__topBackground--FGNS2 {
    position: absolute;
    top: 0;
    right: 0;
    background-repeat: no-repeat;
    z-index: 1;
    width: 100%;
    height: 201px;
    background-size: cover;
    background-position: top right;
    transform: rotate(180deg);
}

@media screen and (min-width: 1024px) {

.PrelanderLimitedOfferPage__topBackground--FGNS2 {
        height: 43vh
}
    }

.PrelanderLimitedOfferPage__bottomBackground--JkcuA {
    position: absolute;
    bottom: 0;
    right: 0;
    background-repeat: no-repeat;
    z-index: 1;
    width: 100%;
    height: 553px;
    background-size: cover;
    background-position: top right;
}

@media screen and (min-width: 1024px) {

.PrelanderLimitedOfferPage__bottomBackground--JkcuA {
        height: 43vh
}
    }
`, "",{"version":3,"sources":["webpack://./src/pages/PrelanderLimitedOfferPage/PrelanderLimitedOfferPage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,iCAAiC;IACjC,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,UAAU;AAQd;;AANI;;AAbJ;QAcQ,eAAe;QACf,iBAAiB;QACjB,8BAA8B;QAC9B;AAER;IADI;;AAGJ;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AAKvB;;AAHI;;AANJ;QAOQ;AAER;IADI;;AAIA;QACI,YAAY;QACZ,YAAY;IAChB;;AAGJ;IACI,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;AAOvB;;AALI;;AARJ;QASQ,eAAe;QACf,iBAAiB;QACjB;AAER;IADI;;AAGJ;IACI,WAAW;IACX,WAAW;IACX,wCAAwC;AAS5C;;AAPI;;AALJ;QAMQ;AAMR;IALI;;AAEA;QACI,cAAc;IAClB;;AAGJ;IACI,mBAAmB;AAKvB;;AAHI;;AAHJ;QAIQ;AAER;IADI;;AAGJ;IACI,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;AAKtB;;AAHI;;AARJ;QASQ;AAER;IADI;;AAGJ;IACI,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;AAOtB;;AALI;;AARJ;QASQ,eAAe;QACf,iBAAiB;QACjB;AAER;IADI;;AAGJ;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AAQb;;AANI;;AALJ;QAMQ,aAAa;QACb,iCAAiC;QACjC,kBAAkB;QAClB;AAER;IADI;;AAGJ;IACI,kBAAkB;IAClB,4CAA4C;IAC5C,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,aAAa;AAKjB;;AAHI;QACI,gBAAgB;IACpB;;AAGJ;IACI,iCAAiC;IACjC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,gDAAgD;IAChD,aAAa;AACjB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;AAOvB;;AALI;;AARJ;QASQ,eAAe;QACf,iBAAiB;QACjB;AAER;IADI;;AAGJ;IACI,cAAc;AAKlB;;AAHI;;AAHJ;QAIQ;AAER;IADI;;AAGJ;IACI,aAAa;IACb,gCAAgC;IAChC,aAAa;IACb,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AAcrB;;AAZI;QACI,kBAAkB;IACtB;;AAEA;;AAbJ;QAcQ,eAAe;QACf;AAMR;;QAJQ;YACI,mBAAmB;QACvB;IACJ;;AAGJ;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;AAOpB;;AALI;;AAVJ;QAWQ,cAAc;QACd,gBAAgB;QAChB;AAER;IADI;;AAGJ;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,4BAA4B;IAC5B,UAAU;IACV,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,yBAAyB;AAK7B;;AAHI;;AAZJ;QAaQ;AAER;IADI;;AAGJ;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,4BAA4B;IAC5B,UAAU;IACV,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAKlC;;AAHI;;AAXJ;QAYQ;AAER;IADI","sourcesContent":[".container {\n    position: relative;\n    background-color: var(--darkest-color);\n}\n\n.root {\n    padding: 16px;\n    width: 100%;\n    max-width: 860px;\n    margin: 0 auto;\n    min-height: 100vh;\n    min-height: calc(var(--vh) * 100);\n    display: flex;\n    flex-direction: column;\n    gap: 28px;\n    position: relative;\n    z-index: 2;\n\n    @media (--large), (--small-tablet) {\n        padding: 32px 0;\n        min-height: 100vh;\n        justify-content: space-between;\n        gap: 24px;\n    }\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n\n    @media (--large), (--small-tablet) {\n        margin-bottom: 32px;\n    }\n}\n\n.logo {\n    > img {\n        width: 103px;\n        height: 24px;\n    }\n}\n\n.title {\n    color: var(--tertiary-color);\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 24px;\n    text-transform: uppercase;\n    margin-bottom: 24px;\n\n    @media (--large), (--small-tablet) {\n        font-size: 32px;\n        line-height: 34px;\n        margin-bottom: 32px;\n    }\n}\n\n.divider {\n    width: 48px;\n    height: 1px;\n    background-color: var(--secondary-color);\n\n    @media (--large), (--small-tablet) {\n        width: 144px;\n    }\n\n    &.center {\n        margin: 0 auto;\n    }\n}\n\n.countdownBlock {\n    margin-bottom: 28px;\n\n    @media (--large), (--small-tablet) {\n        margin-bottom: 40px;\n    }\n}\n\n.countdownBlockLabel {\n    color: var(--secondary-color);\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 16px;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n\n    @media (--large), (--small-tablet) {\n        margin-bottom: 2px;\n    }\n}\n\n.countdownBlockTitle {\n    color: var(--tertiary-color);\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 24px;\n    text-transform: uppercase;\n    margin-bottom: 8px;\n\n    @media (--large), (--small-tablet) {\n        font-size: 32px;\n        line-height: 34px;\n        margin-bottom: 24px;\n    }\n}\n\n.offerBlock {\n    display: flex;\n    flex-direction: column;\n    gap: 28px;\n\n    @media (--large), (--small-tablet) {\n        display: grid;\n        grid-template-columns: 420px auto;\n        align-items: start;\n        grid-gap: 20px;\n    }\n}\n\n.cardsBox {\n    border-radius: 6px;\n    border: 1px solid var(--premium-solid-color);\n    position: relative;\n    overflow: hidden;\n}\n\n.cardsBoxImage {\n    width: 100%;\n    height: auto;\n    aspect-ratio: 4.2 / 3.6;\n}\n\n.cardsBoxDescription {\n    color: var(--premium-solid-color);\n    text-align: center;\n    font-size: 20px;\n    font-weight: 400;\n    line-height: 24px;\n    letter-spacing: 1.2px;\n    text-transform: uppercase;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    padding: 16px;\n\n    > strong {\n        font-weight: 900;\n    }\n}\n\n.additionalText {\n    color: var(--premium-solid-color);\n    text-align: center;\n    font-size: 14px;\n    font-weight: 500;\n    letter-spacing: 0.84px;\n    text-transform: uppercase;\n    padding: 8px 16px 0 16px;\n}\n\n.startedBlock {\n    border-radius: 6px;\n    border: 1px solid var(--dark-tertiary-new-color);\n    padding: 16px;\n}\n\n.startedBlockTitle {\n    color: var(--tertiary-color);\n    font-size: 20px;\n    font-weight: 500;\n    line-height: 24px;\n    text-transform: uppercase;\n    margin-bottom: 16px;\n\n    @media (--large), (--small-tablet) {\n        font-size: 28px;\n        line-height: 32px;\n        margin-bottom: 32px;\n    }\n}\n\n.list {\n    margin: 24px 0;\n\n    @media (--large), (--small-tablet) {\n        margin: 32px 0;\n    }\n}\n\n.listItem {\n    display: grid;\n    grid-template-columns: 14px auto;\n    grid-gap: 8px;\n    color: var(--tertiary-color);\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 16px;\n\n    &:not(:last-child) {\n        margin-bottom: 8px;\n    }\n\n    @media (--large), (--small-tablet) {\n        font-size: 16px;\n        line-height: 20px;\n\n        &:not(:last-child) {\n            margin-bottom: 24px;\n        }\n    }\n}\n\n.button {\n    width: 100%;\n    padding: 16px;\n}\n\n.copyrightText {\n    color: var(--dark-fourth-new-color);;\n    text-align: center;\n    font-size: 10px;\n    font-weight: 500;\n    line-height: 16px;\n    letter-spacing: 0.1px;\n    text-transform: uppercase;\n    margin-top: 16px;\n\n    @media (--large), (--small-tablet) {\n        margin: 0 auto;\n        margin-top: 24px;\n        max-width: 604px;\n    }\n}\n\n.topBackground {\n    position: absolute;\n    top: 0;\n    right: 0;\n    background-repeat: no-repeat;\n    z-index: 1;\n    width: 100%;\n    height: 201px;\n    background-size: cover;\n    background-position: top right;\n    transform: rotate(180deg);\n\n    @media (--large) {\n        height: 43vh;\n    }\n}\n\n.bottomBackground {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    background-repeat: no-repeat;\n    z-index: 1;\n    width: 100%;\n    height: 553px;\n    background-size: cover;\n    background-position: top right;\n\n    @media (--large) {\n        height: 43vh;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PrelanderLimitedOfferPage__container--E9qfQ`,
	"root": `PrelanderLimitedOfferPage__root--pc2Vf`,
	"header": `PrelanderLimitedOfferPage__header--GesUT`,
	"logo": `PrelanderLimitedOfferPage__logo--JVGpG`,
	"title": `PrelanderLimitedOfferPage__title--DYN1j`,
	"divider": `PrelanderLimitedOfferPage__divider--ih0Oh`,
	"center": `PrelanderLimitedOfferPage__center--U06Sa`,
	"countdownBlock": `PrelanderLimitedOfferPage__countdownBlock--cK6Dy`,
	"countdownBlockLabel": `PrelanderLimitedOfferPage__countdownBlockLabel--fz1lK`,
	"countdownBlockTitle": `PrelanderLimitedOfferPage__countdownBlockTitle--rU41a`,
	"offerBlock": `PrelanderLimitedOfferPage__offerBlock--gZmRS`,
	"cardsBox": `PrelanderLimitedOfferPage__cardsBox--eflXI`,
	"cardsBoxImage": `PrelanderLimitedOfferPage__cardsBoxImage--HJcyF`,
	"cardsBoxDescription": `PrelanderLimitedOfferPage__cardsBoxDescription--j6yoI`,
	"additionalText": `PrelanderLimitedOfferPage__additionalText--AXNNJ`,
	"startedBlock": `PrelanderLimitedOfferPage__startedBlock--qz2pp`,
	"startedBlockTitle": `PrelanderLimitedOfferPage__startedBlockTitle--nbAzC`,
	"list": `PrelanderLimitedOfferPage__list--d0ilI`,
	"listItem": `PrelanderLimitedOfferPage__listItem--lHBTR`,
	"button": `PrelanderLimitedOfferPage__button--hSCoZ`,
	"copyrightText": `PrelanderLimitedOfferPage__copyrightText--ZSRxs`,
	"topBackground": `PrelanderLimitedOfferPage__topBackground--FGNS2`,
	"bottomBackground": `PrelanderLimitedOfferPage__bottomBackground--JkcuA`
};
export default ___CSS_LOADER_EXPORT___;
